import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export interface UserBillingData {
  vat: string;
  isVatVerified: boolean;
  company: string;
  countryCode: string;
  city: string;
  state: string;
  zip: string;
  address: string;
  address2: string;
}

export type GetBillingInformation = (
  userId: number,
) => Promise<{ data: UserBillingData }>;

export default (makeCall: MakeCall) => (userId: number) =>
  makeCall<UserBillingData>('GET', `/user/${userId}/billing-data`).then(
    res => ({
      ...res,
      data: {
        ...res.data,
        countryCode: (res.data.countryCode || '').toUpperCase(),
      },
    }),
  );
